import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge taught about the dashboard type scale (`--text-body`,
 * `--text-caption`, `--text-meta` in globals.css). Without this the default
 * config classifies `text-meta` as a text *colour*, so any neighbouring
 * `text-muted-foreground` silently wins and the size token is dropped.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["body", "caption", "meta"] }],
    },
  },
});

/** Joins conditional class values and resolves conflicting Tailwind utilities, last one winning. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
